export function formatBRL(value: number | null | undefined): string {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value ?? 0);
}

/** Exibe R$ 00,00 quando o valor não está disponível ou é zero (cards de métricas). */
export function formatBRLMetrica(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value) || value <= 0) {
    return "R$ 00,00";
  }
  return formatBRL(value);
}

/** Custo unitário na unidade padrão do insumo (ex.: R$ 1,00 / un). */
export function formatCustoPorUnidade(valor: number | null | undefined, unidade: string): string {
  if (valor == null || !Number.isFinite(valor)) {
    return "—";
  }
  const u = (unidade || "un").trim() || "un";
  return `${formatBRL(valor)} / ${u}`;
}

import { parseMoneyMask } from "./moneyMask";

export { maskMoneyInput, parseMoneyMask, numberToMoneyMask } from "./moneyMask";

export function parseNumeroBR(raw: string): number | null {
  const t = raw.trim();
  if (t === "") return null;
  const n = parseMoneyMask(t);
  return Number.isFinite(n) ? n : null;
}
